<template>
    <div>
        <head-layout />

        <v-row class="secondary--text">
            <v-col>
                <div class="text-h4">King Sound Reinforcement Account Form</div>

                <div class="text-subtitle-1 mt-4">Sign up for an account</div>
            </v-col>
        </v-row>

        <account-form-fields
            v-if="!success"
            v-model="form"
            @submit="submit"
            ref="form"
        />

        <form-section v-if="success">
            Thanks, we have received your application and will be in touch soon!
        </form-section>

        <v-snackbar
            v-model="snackbar"
            top
            :timeout="2000"
            color="error"
            rounded
        >
            Please check for Errors
        </v-snackbar>

        <v-snackbar
            v-model="serverErrors"
            top
            :timeout="4000"
            color="error"
            rounded
        >
            {{ errorMessage }}
        </v-snackbar>
    </div>
</template>

<script>
import HeadLayout from "../Layouts/HeadLayout";
import FormSection from "../Components/Forms/FormSection";
import AccountFormFields from "../Components/AccountForm/AccountFormFields";

export default {
    name: "AccountFormCreate",
    components: {
        AccountFormFields,
        FormSection,
        HeadLayout,
    },

    data() {
        return {
            snackbar: false,
            serverErrors: false,
            errorMessage: "",
            success: false,
            form: this.$inertia.form({
                organisation_type: "limited",
                name: "",
                dob: "",
                company_name: "",
                time_at_address: "",
                phone: "",
                mobile_phone: "",
                email: "",
                address: {
                    street: "",
                    city: "",
                    county: "",
                    postcode: "",
                    country_id: 1,
                },
                company_number: "",
                vat_number: "",
                accounts_contact: "",
                accounts_phone: "",
                accounts_email: "",
                accounts_address_same: true,
                accounts_address: {
                    street: "",
                    city: "",
                    county: "",
                    postcode: "",
                    country_id: 1,
                },
                credit_required: false,
                credit_amount: "",
                banker_name: "",
                bank_address: {
                    street: "",
                    city: "",
                    county: "",
                    postcode: "",
                    country_id: 1,
                },
                bank_phone: "",
                bank_sort_code: "",
                bank_account_number: "",
                ref_one_company_name: "",
                ref_one_address: {
                    street: "",
                    city: "",
                    county: "",
                    postcode: "",
                    country_id: 1,
                },
                ref_one_contact_name: "",
                ref_one_email: "",
                ref_one_phone: "",
                ref_two_company_name: "",
                ref_two_address: {
                    street: "",
                    city: "",
                    county: "",
                    postcode: "",
                    country_id: 1,
                },
                ref_two_contact_name: "",
                ref_two_email: "",
                ref_two_phone: "",
                photo_id: null,
                proof_of_address: null,
                insurance_proof: null,
                terms_accepted: false,
                signature_name: "",
                signature_position: "",
                signature_date: new Date().toDateString(),
                signature_image: "",
                marketing_email: false,
                marketing_post: false,
                marketing_phone: false,
                marketing_sms: false,
            }),
        };
    },

    methods: {
        async submit() {
            if (!this.$refs.form.validate()) {
                this.snackbar = true;
                return;
            }

            this.form.signature_image = await this.$refs.form.getSignature();

            this.form.post(this.route("account-form.store"), {
                onError: (errors) => {
                    if (Object.keys(errors).length) {
                        this.errorMessage = errors[Object.keys(errors)[0]];
                        this.serverErrors = true;
                    } else {
                        this.snackbar = true;
                    }
                },
                onSuccess: () => {
                    this.success = true;
                },
            });
        },
    },
};
</script>

<style scoped></style>
